import { FC } from 'react';

import { css } from '@emotion/react';
import { ToucanComponents } from '@jointoucan/toucan-design';
import { CircularProgress, useTheme } from '@mui/material';

const { Button } = ToucanComponents;

interface LoadingButtonProps {
  isLoading: boolean;
  [key: string]: any;
}

const LoadingButton: FC<LoadingButtonProps> = ({ children, isLoading, ...props }) => {
  const theme = useTheme();

  return (
    <Button {...props}>
      <span
        css={css`
          position: relative;
        `}
      >
        <span
          css={css`
            transition: opacity 0.3s;
            opacity: ${isLoading ? 0 : 1};
          `}
        >
          {children}
        </span>
        <span
          css={css`
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            transition: opacity 0.3s;
            visibility: ${isLoading ? 'visible' : 'collapse'};
            opacity: ${isLoading ? 1 : 0};
          `}
        >
          <CircularProgress size={theme.spacing(3)} color="inherit" />
        </span>
      </span>
    </Button>
  );
};

export default LoadingButton;
